export default __webpack_public_path__ + "static/media/EI5-1.22589bcc.jpg";